import { COPY_VERSION, PUBLISH_LATEST } from '../types';
import { createAxiosAction } from '../utils';

export default {
  copy: (fromVersion, toVersion) => {
    return createAxiosAction({
      url: `/api/v1/builds/copy?fromVersion=${fromVersion}&toVersion=${toVersion}`,
      method: 'POST',
      startAction: COPY_VERSION,
    });
  },
  publishLatest: projectId => {
    return createAxiosAction({
      url: `/api/v1/builds/latest?projectId=${projectId}`,
      method: 'POST',
      startAction: PUBLISH_LATEST,
    });
  },
};
